import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import Util from "classes/Util";
import StopPaymentHistoryPage, { getDefaultPageUI } from "components/pages/StopPaymentHistoryPage";
import Classes from "model";
import { useEffect } from "react";

export default function CaptureStopPaymentHistoryResults(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const { branding } = context.state;

    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
        .update([ "showPayments" ], true)
        .submit();

    useEffect(() => {
        Util.replaceDOMDataPointValues(branding);
    });

    return <StopPaymentHistoryPage ui={ ui } />
}